import {CheckCircle, Info, Warning, XCircle} from '@phosphor-icons/react';
import {func, node, string} from 'prop-types';
import {useMemo} from 'react';
import {twMerge} from 'tailwind-merge';

export default function Message({variant = 'info', children, onClick, className = ''}) {
  const alertType = useMemo(() => {
    let type = '';

    switch (variant) {
      case 'warning':
        type = 'alert-warning';
        break;
      case 'error':
        type = 'alert-error';
        break;
      case 'success':
        type = 'alert-success';
        break;
      default:
        type = 'alert-info';
    }

    return type;
  }, [variant]);

  return (
    <div
      className={twMerge(
        'alert flex items-start justify-start relative p-2 md:p-2.5 gap-2',
        alertType,
        className,
        onClick ? `cursor-pointer hover:bg-${alertType}/60` : ''
      )}
      onClick={onClick}
    >
      {variant === 'success' && <CheckCircle className="shrink-0" size={20} />}
      {variant === 'info' && <Info className="shrink-0" size={20} />}
      {variant === 'warning' && <Warning className="shrink-0" size={20} />}
      {variant === 'error' && <XCircle className="shrink-0" size={20} />}
      {variant === 'ping' && (
        <div className="relative flex h-4 w-5 items-center justify-center">
          <span className="absolute h-3 w-3 rounded-full">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-info-content opacity-90"></span>
            <span className="relative mb-3 inline-flex h-3 w-3 rounded-full bg-info-content"></span>
          </span>
        </div>
      )}

      <div className="w-full text-left text-sm">{children}</div>
    </div>
  );
}

Message.propTypes = {
  children: node.isRequired,
  className: string,
  onClick: func,
  variant: string,
};
